import { useMediaQuery } from 'react-responsive';

type BreakpointKey = 'sm' | 'md' | 'lg' | 'xl' | '2xl';

// Lazily resolve breakpoints from Tailwind v4 CSS variables (--breakpoint-*)
let breakpoints: Record<BreakpointKey, string> | null = null;

function getBreakpoints(): Record<BreakpointKey, string> {
    if (!breakpoints) {
        const styles = getComputedStyle(document.documentElement);
        breakpoints = {
            sm: styles.getPropertyValue('--breakpoint-sm').trim(),
            md: styles.getPropertyValue('--breakpoint-md').trim(),
            lg: styles.getPropertyValue('--breakpoint-lg').trim(),
            xl: styles.getPropertyValue('--breakpoint-xl').trim(),
            '2xl': styles.getPropertyValue('--breakpoint-2xl').trim(),
        };
    }
    return breakpoints;
}

export function useBreakpoint<K extends BreakpointKey>(breakpointKey: K) {
    const bool = useMediaQuery({
        query: `(min-width: ${getBreakpoints()[breakpointKey]})`,
    });
    const capitalizedKey = breakpointKey.charAt(0).toUpperCase() + breakpointKey.slice(1);
    type Key = `is${Capitalize<K>}`;
    const key = `is${capitalizedKey}` as Key;

    return { [key]: bool } as Record<Key, boolean>;
}
